import { PlanSeriesName } from '../RetirementChart.meta';

/**
 * We want to display the series with the highest points first in the stack order.
 * This is to prevent the taller chart from completely hiding the other one behind it.
 */
export const getSeriesStackOrder = (
  currentPlanSeries: number[],
  recommendedPlanSeries: number[],
  isCurrentPlanSelected: boolean,
): PlanSeriesName[] => {
  const currentPlanSeriesTopPoints = currentPlanSeries.reduce((acc, value, index) => {
    return acc + (value > recommendedPlanSeries[index] ? 1 : 0);
  }, 0);

  const proposedPlanSeriesTopPoints = recommendedPlanSeries.reduce((acc, value, index) => {
    return acc + (value > currentPlanSeries[index] ? 1 : 0);
  }, 0);

  if (currentPlanSeriesTopPoints >= proposedPlanSeriesTopPoints && !isCurrentPlanSelected) {
    return [PlanSeriesName.Current, PlanSeriesName.Recommended];
  }

  return [PlanSeriesName.Recommended, PlanSeriesName.Current];
};
